import { publish } from './publish';

export interface TrackingActionType {
  action: string;
  category?: string;
  label?: string;
  [key: string]: any;
}

export const MFE_TRACK_EVENT = 'sxm_mfe_track';

export function track(action: TrackingActionType) {
  publish(MFE_TRACK_EVENT, action);
}
